(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rbs-homepage-rotation"] && !Shopify.designMode) return;
  try {
    (() => {
  const shuffled = (items, key, identity) => {
    const result = [...items];
    for (let i = result.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
    try {
      const storageKey = `rbs-home-rotation:${key}`;
      const previous = sessionStorage.getItem(storageKey);
      if (result.length > 1 && identity(result[0]) === previous) {
        const different = result.findIndex(item => identity(item) !== previous);
        if (different > 0) [result[0], result[different]] = [result[different], result[0]];
      }
      if (result.length) sessionStorage.setItem(storageKey, identity(result[0]));
    } catch {}
    return result;
  };
  const productKey = card => card.querySelector('a[href*="/products/"]')?.getAttribute('href') || card.textContent.trim();
  const rotate = root => {
    root.querySelectorAll('[data-rbs-product-row]:not([data-rbs-rotated])').forEach(row => {
      const pool = [...root.querySelectorAll('template[data-rbs-product-pool]')].find(template => template.dataset.rbsProductPool === row.dataset.rbsProductRow);
      if (!pool) return;
      const cards = [...pool.content.children].filter(card => card.tagName === 'LI');
      if (cards.length) {
        const count = Math.max(1, Number(row.dataset.rbsProductCount) || 8);
        const chosen = shuffled(cards, row.dataset.rbsProductRow, productKey).slice(0, count);
        row.replaceChildren(...chosen.map(card => card.cloneNode(true)));
      }
      row.dataset.rbsRotated = 'true';
      pool.remove();
    });
    root.querySelectorAll('[data-rbs-shuffle-row]:not([data-rbs-rotated])').forEach(row => {
      const cards = [...row.children].filter(card => card.tagName === 'LI');
      row.replaceChildren(...shuffled(cards, row.dataset.rbsShuffleRow, productKey));
      row.dataset.rbsRotated = 'true';
    });
    root.querySelectorAll('[data-rbs-look]:not([data-rbs-rotated])').forEach(tile => {
      let options;
      try { options = JSON.parse(tile.dataset.rbsLookOptions); } catch { return; }
      if (!Array.isArray(options) || !options.length) return;
      const chosen = shuffled(options, tile.dataset.rbsLook, item => item.image);
      const first = chosen[0];
      const pictures = tile.querySelectorAll('figure > picture');
      pictures.forEach((picture, index) => {
        const img = picture.querySelector('img');
        if (!img) return;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = index ? first.hover : first.image;
        img.alt = first.alt;
        img.style.objectFit = 'contain';
      });
      const button = tile.querySelector('[data-shopthelook]');
      if (button) button.dataset.products = JSON.stringify(chosen.slice(0, 3).map(item => item.url));
      tile.dataset.rbsSelectedProduct = first.key;
      tile.dataset.rbsRotated = 'true';
      tile.removeAttribute('data-rbs-look-options');
    });
  };
  rotate(document);
  document.addEventListener('shopify:section:load', event => rotate(event.target), true);
})();
  } catch(e) { console.error(e); }
})();

})();
